import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {DocumentsReviewFilters} from '../../../../../Models/Documents-review/documents-review-filters.model';
import {DocumentsReviewDto} from '../../../../../Models/Documents-review/documents-review.interface';
import {DocumentsReviewApiService} from '../../../../../Services/Api/Documents-review/documents-review-api.service';

export interface DocumentsReviewWidgetData {
  deliveryNotes: number;
  expenses: number;
  payrolls: number;
  unclassified: number;
}

@Component({
  selector: 'app-documents-review-widget',
  templateUrl: './documents-review-widget.component.html',
  styleUrls: ['./documents-review-widget.component.scss'],
  standalone: false,
})
export class DocumentsReviewWidgetComponent extends WidgetDataControllerComponent<DocumentsReviewWidgetData> {

  override fakeData: DocumentsReviewWidgetData = {
    deliveryNotes: 6,
    expenses: 1,
    payrolls: 3,
    unclassified: 2,
  };

  get widgetData(): DocumentsReviewWidgetData {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected documentsReviewService: DocumentsReviewApiService,
  ) {
    super(injector, documentsReviewService);
  }


  /**
   * Ir a una sección específica
   *
   */
  goToSection(event: Event, menu: string) {
    event.stopPropagation();
    this.onClickWidget({menu});
  }


  /**
   * Establecer datos
   *
   */
  override setData(data: DocumentsReviewDto) {
    this.data = {
      deliveryNotes: data?.delivery_notes?.length || 0,
      expenses: data?.expenses?.filter((item) => item.pendiente_ocr || item.error_ocr)?.length || 0,
      payrolls: data?.payrolls?.filter((item) => item.pendiente_ocr || item.error_ocr)?.length || 0,
      unclassified: data?.unclassified?.length || 0,
    };
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters = new DocumentsReviewFilters();
    filters.store_id = this.widgetsManager.filters ? this.widgetsManager.filters.local?.id : 0;

    return this.documentsReviewService.getDocumentsReview(filters);
  }

}
